import React from 'react';
import { useTranslation } from 'react-i18next';
import { BaseCard } from './BaseCard';
import { PendingTasksCardProps } from './CardProps';
import { DASHBOARD_CARD_TITLE_KEYS } from './dashboardCardKeys';
import { DashboardMetricContent } from './DashboardMetricContent';

export const PendingTasksCard: React.FC<PendingTasksCardProps> = ({
  cardId,
  pendingTasks,
  onClick,
}) => {
  const { t } = useTranslation();
  const cardTitle = t(DASHBOARD_CARD_TITLE_KEYS[cardId]!);

  return (
    <BaseCard cardId={cardId} title={null} onClick={onClick}>
      <DashboardMetricContent label={cardTitle} value={pendingTasks} />
    </BaseCard>
  );
};
